export enum MifidCategoryCode {
    MI = 'MI',
    CR = 'CR',
    PR = 'PR',
}
